<template>
    <section>
        <v-container class="nav">
            <v-card-title>
                <v-row align="center">
                    <v-col
                        cols="2"
                        sm="2"
                        lg="1"
                        class="pr-0"
                        align="right"
                    >
                        <v-avatar class="page-icon teal mr-2 elevation-5">
                            <v-icon large class="white--text">
                                {{ mdiPaperclip }}
                            </v-icon>
                        </v-avatar>
                    </v-col>
                    <v-col
                        cols="10"
                        sm="10"
                        lg="11"
                        class="pl-0"
                    >
                        <h2 style="word-break: normal;">
                            Annual Check-Up Approval Result
                        </h2>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-divider />
        </v-container>
        <!-- <v-card-text class="mt-6" v-if=" getOppaResult.OPPAN_NO"> -->
        <v-card-text v-if="getACUResult.OPAN_N">
            <h1>OPPA NO: NOT AVAILABLE</h1>
            <br>
            <v-divider />
            <br>
            <p><b>THIS REQUEST WAS DENIED!</b></p>
            <p>Your request for Annual Check up on {{ getACUResult.CLINIC_NAME }} was denied due to the following reason: </p>
            <p> REASON: <b>{{ getACUResult.ERROR }}</b><br> </p>
            <!-- <div v-if="getOppaResult.AR"> -->
            <div v-if="getACUResult.AR">
                <v-data-table
                    :headers="headers"
                    :items="getData"
                    :items-per-page="5"
                    no-data-text
                    :footer-props="footer_props"
                    class="my-10 elevation-10"
                    :class="{ mobile: screen_width < 968 }"
                    :hide-headers="true"
                >
                    <template #item="{ item }">
                        <tr v-if="screen_width < 600">
                            <td colspan="7">
                                <ul class="flex-content">
                                    <div class="content d-flex justify-space-between" style="width:100%">
                                        <label>Debit Memo #.:</label>
                                        <li class="flex-item" data-label="Calories">
                                            {{ item.DMNO_N }}
                                        </li>
                                    </div>
                                    <div class="content d-flex justify-space-between" style="width:100%">
                                        <label>Date:</label>
                                        <li class="flex-item" data-label="Calories">
                                            {{ item.DMDA_D }}
                                        </li>
                                    </div>
                                    <div class="content d-flex justify-space-between" style="width:100%">
                                        <label>EHB:</label>
                                        <li class="flex-item" data-label="Calories">
                                            {{ item.DUEH_A }}
                                        </li>
                                    </div>
                                    <div class="content d-flex justify-space-between" style="width:100%">
                                        <label>PH:</label>
                                        <li class="flex-item" data-label="Calories">
                                            {{ item.DUME_A }}
                                        </li>
                                    </div>
                                    <div class="content d-flex justify-space-between" style="width:100%">
                                        <label>EHB(PAID):</label>
                                        <li class="flex-item" data-label="Calories">
                                            {{ item.PAEH_A }}
                                        </li>
                                    </div>
                                    <div class="content d-flex justify-space-between" style="width:100%">
                                        <label>PH(PAID):</label>
                                        <li class="flex-item" data-label="Calories">
                                            {{ item.PAME_A }}
                                        </li>
                                    </div>
                                    <div class="content d-flex justify-space-between" style="width:100%">
                                        <label>Remarks:</label>
                                        <li class="flex-item" data-label="Calories">
                                            {{ item.REMA_M }}
                                        </li>
                                    </div>
                                </ul>
                            </td>
                        </tr>
                        <tr v-else>
                            <td v-text="item.DMNO_N"></td>
                            <td v-text="item.DMDA_D"></td>
                            <td v-text="item.DUEH_A"></td>
                            <td v-text="item.DUME_A"></td>
                            <td v-text="item.PAEH_A"></td>
                            <td v-text="item.PAME_A"></td>
                            <td v-text="item.REMA_M"></td>
                        </tr>
                    </template>
                </v-data-table>
                <b>Outstanding Balance</b> (Excluding Interests)<br>
                <br>
                <v-divider />
                <div class="row">
                    <div class="col d-flex">
                        Excess Hospital Bills:
                    </div>
                    <div class="col d-flex">
                        {{ (getACUResult.AR.EHB) }}
                    </div>
                </div>
                <div class="row">
                    <div class="col d-flex">
                        PhilHealth:
                    </div>
                    <div class="col d-flex">
                        {{ (getACUResult.AR.PH) }}
                    </div>
                </div>
                <div class="row">
                    <div class="col d-flex">
                        Total:
                    </div>
                    <div class="col d-flex">
                        {{ (getACUResult .AR.TOTAL) }}
                    </div>
                </div>
                <br>
            </div>
            <p>
                APPROVED: <b>{{ getACUResult.APPROVE ? "YES" : "NO" }}</b><br>
                NAME OF MEDICAL PROVIDER: <b>{{ getACUResult.CLINIC_NAME }}</b><br>
                DATE ISSUED: <b>{{ moment(getACUResult.APPR_D).utcOffset('+0800').format('DD MMMM YYYY') }}</b><br>
                VALID UNTIL: <b>{{ moment(getACUResult.VALI_D).utcOffset('+0800').format('DD MMMM YYYY') }}</b><br>
                NAME OF PATIENT: <b>{{ getACUResult.MEMB.LAST_M }} {{ getACUResult.MEMB.MIDI_M !== null ? `${ (getACUResult.MEMB.MIDI_M)[0] }.` : "" }}</b><br>
                DATE OF BIRTH: <b>{{ moment(getACUResult.MEMB.BIRT_D).utcOffset('+0800').format('DD MMMM YYYY') }}</b><br>
                SEX: <b>{{ getACUResult.MEMB.SEX === "F" ? "FEMALE" : "MALE" }}</b><br>
                CONTRACT NUMBER: <b>{{ getACUResult.MEMB_N }} - {{ getACUResult.MEMB.PROG_C }}</b><br>
            </p>
            <h1>Please contact <a href="https://www.hmi.com.ph/contact">HMI</a>. Thank you!</h1>
        </v-card-text>
        <v-container class="requestWrapper">
            <v-btn
                class=""
                @click="goBack()"
            >
                <h1>Done</h1>
            </v-btn>
        </v-container>
    </section>
</template>
<script>
import { mapGetters } from 'vuex'
import { moment } from '../../../utils/date-shim'
import { mdiPaperclip } from '@mdi/js'
export default {
    data: () => {
        return ({
            mdiPaperclip,
            opan_n: '',
            screen_width: document.documentElement.clientWidth + 9,
            footer_props: {
                'items-per-page-options': []
            },
            headers: [
                {
                    text: 'Debit Memo No.',
                    align: 'left',
                    value: 'DMNO_N',
                    class: 'teal--text'
                },
                {
                    text: 'Date',
                    align: 'left',
                    value: 'DMDA_D',
                    class: 'teal--text'
                },
                {
                    text: 'EHB',
                    align: 'left',
                    value: 'DUEH_A',
                    class: 'teal--text'
                },
                {
                    text: 'PH',
                    align: 'left',
                    value: 'DUME_A',
                    class: 'teal--text'
                },
                {
                    text: 'PAID EHB',
                    align: 'left',
                    value: 'PAEH_A',
                    class: 'teal--text'
                },
                {
                    text: 'PAID PH',
                    align: 'left',
                    value: 'PAME_A',
                    class: 'teal--text'
                },
                {
                    text: 'Remarks',
                    align: 'left',
                    value: 'REMA_M',
                    class: 'teal--text'
                }
            ]
        })
    },
    computed: {
        ...mapGetters(['getACUResult']),
        getData: {
            get(){
                let row = this.getACUResult.AR.ROW
                let data = []
                if (row) {
                    for (var i = 0; i < row.length; i++) {
                        data.push({
                            DMNO_N: row[i].DMNO_N,
                            DMDA_D: moment(row[i].DMDA_D).utcOffset('+0800').format('YYYY-MM-DD'),
                            DUEH_A: `PHP ${(row[i].DUEH_A) ? (row[i].DUEH_A).toFixed(2) : '0.00'}`,
                            DUME_A: `PHP ${(row[i].DUME_A) ? (row[i].DUME_A).toFixed(2) : '0.00'}`,
                            PAEH_A: `PHP ${(row[i].PAEH_A) ? (row[i].PAEH_A).toFixed(2) : '0.00'}`,
                            PAME_A: `PHP ${(row[i].PAME_A) ? (row[i].PAME_A).toFixed(2) : '0.00'}`,
                            REMA_M: row[i].REMA_M
                        })
                    }
                }
                return data
            }
        }
    },
    mounted() {
        window.addEventListener('resize', this.onResize)
    },
    destroyed() {
        window.removeEventListener('resize', this.onResize)
    },
    created () {
        this.opan_n = this.$route.query.OPPAN
    },
    methods: {
        onResize() {
            this.screen_width = document.documentElement.clientWidth
        },
        goBack() {
            this.$router.push('/dashboard/annual-physical-exam')
        }
    }
}
</script>
<style scoped>
.requestWrapper {
    height: 10;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
}
.memberInfoCard {
    width: 70%;
    margin: auto;
}

.flex-content {
    padding: 0;
    margin: 10px auto;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
}

.flex-item {
    padding: 5px;
    width: 100%;
    height: 40px;
    text-align: right;
}

section {
  width: 100%;
  background-image: url("../../../assets/dashboardBG.webp");
  background-position: center;
  background-size: cover;
}
.user-card {
  width: 95%;
}

h1 {
    font-size: 18px;
}

@media (max-width: 390px) {
  .page-icon {
    display: none;
  }
}

@media (max-width: 599px) {
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }

  /* Member Card wrapper */
  .user-card {
    width: 100%;
  }
}

@media (min-width: 599px) and (max-width: 968px) {
  .user-card {
    width: 80%;
  }
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
}

@media (min-width: 968px) and (max-width: 1264px) {
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
}
</style>
